/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActionWithoutLabel } from "./ActionWithoutLabel";
export const Action = core.serialization
    .object({
    label: core.serialization.string(),
})
    .extend(ActionWithoutLabel);
